import { Wrench } from "lucide-react";
import { SITE } from "@/data/site";
import { getServices } from "@/data/services";
import { getServiceFaqsGeneral } from "@/data/faqs";
import { useLang } from "@/lib/i18n";
import ServiceCard from "@/components/site/ServiceCard";
import FAQ from "@/components/site/FAQ";
import ReadyCTA from "@/components/site/ReadyCTA";

export default function Services() {
  const { t, lang } = useLang();
  const SERVICES = getServices(lang);
  const FAQS = getServiceFaqsGeneral(lang);

  return (
    <>
      <section data-testid="services-hero" className="relative bg-brand-navy-dark text-white overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={SITE.vanImage}
            alt=""
            aria-hidden="true"
            className="w-full h-full object-cover"
            style={{ filter: "blur(3px) brightness(0.72) saturate(1.1)" }}
          />
          <div className="absolute inset-0 bg-gradient-to-br from-brand-navy-dark/78 via-brand-navy-dark/62 to-slate-900/78" />
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(255,191,0,0.12)_0%,transparent_60%)]" />
        </div>
        <div className="absolute -top-32 -right-24 w-[480px] h-[480px] rounded-full bg-brand-yellow/20 blur-3xl pointer-events-none" />
        <div className="absolute -bottom-32 -left-24 w-[420px] h-[420px] rounded-full bg-brand-navy-light/25 blur-3xl pointer-events-none" />
        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-brand-yellow/70 to-transparent" />
        <div className="relative container-max py-16 sm:py-24">
          <div className="inline-flex items-center gap-2 rounded-full bg-brand-yellow text-slate-900 px-3.5 py-1.5 text-xs font-bold tracking-wide shadow-lg shadow-yellow-300/20">
            <Wrench size={14} />
            {t.services.heroEyebrow}
          </div>
          <h1
            className="mt-5 font-heading text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight max-w-3xl text-balance"
            style={{ textShadow: "0 2px 16px rgba(0,0,0,0.5)" }}
          >
            {t.services.heroTitle}
          </h1>
          <p
            className="mt-5 text-white/95 text-lg max-w-2xl leading-relaxed"
            style={{ textShadow: "0 1px 8px rgba(0,0,0,0.45)" }}
          >
            {t.services.heroSub}
          </p>
        </div>
      </section>

      <section className="section-padding bg-[radial-gradient(ellipse_at_top,#EFF6FF_0%,#F8FAFC_50%,#F1F5F9_100%)]">
        <div className="container-max">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {SERVICES.map((s) => (
              <ServiceCard key={s.slug} service={s} />
            ))}
          </div>
        </div>
      </section>

      <FAQ items={FAQS} eyebrow={lang === "es" ? "Servicios · FAQ" : "Services · FAQ"} />

      <ReadyCTA />
    </>
  );
}
